export default "__VITE_ASSET__WDUPE4lb__"